import { SonarObjectType } from '@sonar-software/sonar-ts-types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { TimelineBaseRequest, TimelineChangeType } from '@types';

export type TimelineChangeCounts = Record<TimelineChangeType, number>;

export type TimelineSummaryChangeCounts = Partial<Record<SonarObjectType, TimelineChangeCounts>>;

export type GetTimelineSummaryRequest = Omit<TimelineBaseRequest, 'objectFilter'> & {
	applicationIds?: Array<string>;
	tagIds?: Array<string>;
};

export type TimelineSummaryResponse = {
	changeCounts: TimelineSummaryChangeCounts;
	timelineEnd: string;
	timelineStart: string;
};

export const getTimelineSummary = createGetEndpoint<GetTimelineSummaryRequest, TimelineSummaryResponse>(
	(request) => `/api/v3/timelines/summary?${getQueryString(request)}`
);
